import React from 'react'

import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';

function circular() {
  const tabs = [
    { title: 'Circular 2025-26', content: () => <div className='circular-content'> 

<div className='cam-lower-sec'>
    <h1 className='title'>Circular 2025-26</h1>
    </div>

<div className='newsletter-sec-row'>
          <div className='newletter-box'>
            <Link to="../circular/School-Circular-1-2026-27.pdf"
              target="_blank"
              rel="noopener noreferrer"> 
            <div className='newletter-img'>
              <img src="../circular/cricular-26-27.webp" alt="" />
            </div>
            {/* <div className='newsletter-heading'>
              <p>Admission Policy</p>
          
            </div> */}
            </Link>
          </div>
       </div>






</div>


    }
  ];
  return (
    <div>
      <div className='ibdp-hero-sec'>
        <img src='img/Screenshot_29.webp'/>
      </div>
      
            <div className='ib-syllabus'>
        {/* <Igcsedata/> */}
        <HorizontalTabs tabs={tabs} />
      </div>
    </div>
  )
}

export default circular
